/** Keep each result reusable without a background refetch for at least ten minutes. */
export const TIME_SERIES_QUERY_CACHE_TIME_MS = 10 * 60 * 1000;
export const TIME_SERIES_GARBAGE_COLLECTION_TIME_MS = 3 * 60 * 1000;
